<template>
  <div
    v-for="item of items"
    :key="item.value"
    class="flex-none flex border border-solid border-gray-300 cursor-pointer hover:bg-gray-100 gap-3 rounded-full h-8"
    :class="[
      item.value === selectedItem ? 'border-primary-500 text-primary-500 bg-primary-100 hover:bg-primary-200' : '',
      !item.image ? 'px-4' : 'pe-4'
      ]"
    @click="$emit('selected', item.value)"
  >
    <img v-if="item.image" :src="item.image" alt="" class="w-8 h-8 rounded-full">
    <span class="self-center">{{ item.label }}</span>
  </div>
</template>

<script setup lang="ts">
import { PropType } from 'vue';

defineProps({
  items: {
    type: Array as PropType<Array<{ label: string, value: string; image?: string }>>,
    required: true,
    default: () => ([])
  },
  selectedItem: {
    type: String,
    required: true,
    default: ''
  }
})

defineEmits(['selected'])
</script>

<style scoped lang="scss">

</style>
